import React, { useState } from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton, Tooltip } from '@mui/material';
import { CloseRounded, InfoOutlined } from '@mui/icons-material';

type InfoIconButtonProps = {
  ariaLabel?: string;
  tooltip?: string;
  title?: React.ReactNode;
  children?: React.ReactNode;
  size?: 'small' | 'medium' | 'large';
};

export default function InfoIconButton(props: InfoIconButtonProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Tooltip title={props.tooltip ?? ''}>
        <IconButton
          aria-label={props.ariaLabel ?? 'info'}
          onClick={() => setOpen(true)}
          size={props.size ?? 'small'}
        >
          <InfoOutlined fontSize={props.size === 'large' ? 'medium' : 'small'} />
        </IconButton>
      </Tooltip>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth='sm'
        fullWidth
      >
        {props.title && (
          <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            {props.title}
            <IconButton
              aria-label='close'
              onClick={() => setOpen(false)}
              size='small'
            >
              <CloseRounded fontSize='small' />
            </IconButton>
          </DialogTitle>
        )}
        <DialogContent>{props.children ?? 'dummy text'}</DialogContent>
      </Dialog>
    </>
  );
}
